import CodeHighlight from 'dashboard/components-lib/CodeHighlight';
import { ReportScreening } from 'dashboard/models/report/screening';
import Card from 'design-system/components/Card';

interface ScreeningProps {
  report: ReportScreening;
}

const Screening = ({ report }: ScreeningProps) => {
  return (
    <Card>
      <CodeHighlight id='components-report-result_screening' language='json'>
        {JSON.stringify(report.attributes, null, 2)}
      </CodeHighlight>
    </Card>
  );
};

export default Screening;
